/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-04-13 10:45:19
 * @LastEditors: zhangle
 * @LastEditTime: 2022-09-30 09:26:14
 */
let State = {
    DigitalCertificateServicesProtocol: 0, // 数字证书服务协议 0. 不需要弹出更新协议框, 1. 需要弹出.
    approveStatus: '0'
}
let MutAtions = {
    ChgDigitalCertificateServicesProtocol (state, data) {
        state.DigitalCertificateServicesProtocol = data
    },
    setApproveStatus (state, data) {
        state.approveStatus = data
    }
}
export default {
    namespaced: true,
    strict: true,
    state: State,
    // getters: Getters,
    mutations: MutAtions,
    // actions: Actions
};
  


// WEBPACK FOOTER //
// ./src/store/modules/app.js